import api from './api';

// ========== COMPANY MASTER DATA API ==========

// Get all master data (categories with activities and subtasks)
// Now includes both global and company-specific items
export const getMasterData = async () => {
  try {
    const response = await api.get('/masterdata/categories');
    return response.data;
  } catch (error) {
    console.error('Error fetching master data:', error);
    throw error;
  }
};

// ========== COMPANY ACTIVITIES ==========

export const createCompanyActivity = async (activityData) => {
  try {
    const response = await api.post('/masterdata/activities', activityData);
    return response.data;
  } catch (error) {
    console.error('Error creating company activity:', error);
    throw error;
  }
};

export const updateCompanyActivity = async (activityId, activityData) => {
  try {
    const response = await api.put(`/masterdata/activities/${activityId}`, activityData);
    return response.data;
  } catch (error) {
    console.error('Error updating company activity:', error);
    throw error;
  }
};

export const deleteCompanyActivity = async (activityId) => {
  try {
    const response = await api.delete(`/masterdata/activities/${activityId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting company activity:', error);
    throw error;
  }
};

// ========== COMPANY SUBTASKS ==========

export const createCompanySubTask = async (subTaskData) => {
  try {
    const response = await api.post('/masterdata/subtasks', subTaskData);
    return response.data;
  } catch (error) {
    console.error('Error creating company subtask:', error);
    throw error;
  }
};

export const updateCompanySubTask = async (subTaskId, subTaskData) => {
  try {
    const response = await api.put(`/masterdata/subtasks/${subTaskId}`, subTaskData);
    return response.data;
  } catch (error) {
    console.error('Error updating company subtask:', error);
    throw error;
  }
};

export const deleteCompanySubTask = async (subTaskId) => {
  try {
    const response = await api.delete(`/masterdata/subtasks/${subTaskId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting company subtask:', error);
    throw error;
  }
};

export default {
  getMasterData,
  createCompanyActivity,
  updateCompanyActivity,
  deleteCompanyActivity,
  createCompanySubTask,
  updateCompanySubTask,
  deleteCompanySubTask,
};
